<form *ngIf="noteTranslationForm" fxLayout="column" [formGroup]="noteTranslationForm" style="width: 100%; height: 100%">
	<!--Notes-->
	<mat-form-field *ngIf="!loadingTranslationLanguages" id="notes-language-selector-form" subscriptSizing="dynamic">
		<mat-label id="notes-language-selector-label">Notes Language</mat-label>
		<mat-select
			id="notes-language-selector"
			formControlName="translationLanguage"
			(selectionChange)="onNoteLanguageChange($event)"
		>
			<mat-option *ngFor="let translationLanguage of translationLanguages" [value]="translationLanguage">{{
				translationLanguage.language.name
			}}</mat-option>
		</mat-select>
	</mat-form-field>

	<app-spinner *ngIf="loadingTranslation || loadingTranslationLanguages" #noteTranslationSpinner></app-spinner>

	<mat-form-field
		*ngIf="!loadingTranslation && !loadingTranslationLanguages"
		id="translation-notes-form"
		style="width: 100%; height: 100%"
	>
		<mat-label id="translation-notes-label">{{ notesFieldLabel }}</mat-label>
		<textarea
			id="noteTranslation"
			#noteTranslation
			formControlName="notes"
			maxlength="{{ maxCharLength }}"
			style="resize: none; height: 100%"
			aria-label="Notes"
			name="notes"
			title="Notes"
			matInput
			(input)="onNotesChanged($event)"
			(blur)="notesBlurred.emit()"
			[disabled]="loadingTranslation"
		></textarea>
		<mat-hint class="character-counter">{{ noteTranslation.value?.length || 0 }}/{{ maxCharLength }}</mat-hint>
	</mat-form-field>
</form>
